import React from 'react';
import { Box, Flex } from '@cko/primitives';
const Row = ({ children, ...props }) => (React.createElement(Box, { p: "var(--layout-spoon)", borderBottom: "var(--border-b-seed) solid var(--base-border-secondary)", ...props },
    React.createElement(Flex, { alignItems: "center" }, children)));
export default Row;
